import { FC, ReactNode } from 'react';
import { ReactReduxContext } from 'react-redux';

interface Props {
  children: ReactNode;
  Context: typeof ReactReduxContext;
  render: (children: ReactNode) => ReactNode;
}

export const ContextBridge: FC<Props> = ({ children, Context, render }) => {
  return (
    <Context.Consumer>
      {(value: any) => render(<Context.Provider value={value}>{children}</Context.Provider>)}
    </Context.Consumer>
  );
};
